import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { laboratoriesActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class Laboratories extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newLaboratory, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Laboratórios'}
          classes={classes}
          newResource={newLaboratory}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'laboratorios'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.laboratories.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(laboratoriesActions.openModal())
    },
    closeModal: () => {
      dispatch(laboratoriesActions.closeModal())
    },
    newLaboratory: laboratory => {
      dispatch(laboratoriesActions.newFormLaboratory(laboratory))
    },
    resetState: () => {
      dispatch(laboratoriesActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Laboratories))



// WEBPACK FOOTER //
// ./src/containers/Laboratories/index.js